import { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { useGetBusinessPlanPDFBinaryData } from 'services/businessPlan/hooks/useGetBusinessPlanPDFBinaryData';

import { Loader } from 'components/_basic/Loader/Loader';
import { NavigateToErrorPage } from 'components/_basic/NavigateToErrorPage';

export const PDFViewPage: FC = () => {
  const { id = '' } = useParams();
  const { data: blob, isError, isFetching } = useGetBusinessPlanPDFBinaryData(id);

  useEffect(() => {
    if (!isFetching && !isError && blob) {
      const blobUrl = URL.createObjectURL(blob);
      window.location.href = blobUrl;
    }
  }, [isFetching, isError, blob]);

  if (isFetching)
    return (
      <>
        <Helmet>
          <script type="text/javascript" defer>
            {`
            window.dataLayer = window.dataLayer || [];
            let userId = '';
            try {
              const userStore = localStorage.getItem('user-store');
              if (userStore) {
                const parsed = JSON.parse(userStore);
                userId = parsed?.state?.authUser?.id || '';
                dataLayer.push({ user_id: userId });
              }
            } catch (e) {
              console.error('Failed to parse user-store:', e);
            }
          `}
          </script>
          <script type="text/javascript" defer>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                          })(window,document,'script','dataLayer','GTM-PB57NZW9');`}
          </script>
          <script type="text/javascript" defer>
            {`!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '951508482576405');
            fbq('track', 'PageView');`}
          </script>
        </Helmet>
        <Loader />
      </>
    );

  if (isError) return <NavigateToErrorPage errorCode="404" replace />;

  return null;
};
